import React from 'react'
import { FunctionListWrapper } from './styles'

export const List: React.FC = () => {
  const functioning = [
    {
      key: 'function1',
      title: 'Desde donde estés',
      content:
        'Ingresa desde tu canal digital de preferencia Banca Web, Banca Móvil o Página web oficial de Banco Pichincha.',
    },
    {
      key: 'function2',
      title: 'Tranquilidad asegurada',
      content:
        'De inicio a fin, tus datos están protegidos por los más altos estándares de seguridad.',
    },
    {
      key: 'function3',
      title: 'Total libertad',
      content:
        'Escoge el monto, plazo y día de pago que prefieras, el control lo tienes tú.',
    },
    {
      key: 'function4',
      title: 'Transparencia en cada paso',
      content:
        'Sin cobros sorpresa, conocerás todos los detalles de tu préstamo antes de aceptar el desembolso.',
    },
  ]

  return (
    <FunctionListWrapper>
      <div className="bp-mx-64 size-list">
        <dl>
          {functioning.map((a, index) => (
            <div key={a.key} className="list-flex">
              <div className="list-icon">
                <pichincha-icon size="28px" color="success" type="--outlined">
                  done
                </pichincha-icon>
              </div>
              <div className="text-wrapper">
                <dt key={index}>
                  <pichincha-typography
                    class="bp-mb-4"
                    variant="h6"
                    weight="bold"
                    color="blue"
                    weight_color="500"
                  >
                    {a.title}
                  </pichincha-typography>
                </dt>
                <dt key={a.title}>
                  <pichincha-typography class="bp-mb-8">
                    {a.content}
                  </pichincha-typography>
                </dt>
              </div>
            </div>
          ))}
        </dl>

        <div className="sizebutton button-spacer">
          <pichincha-button href="#logo-pb">Deseo mi préstamo</pichincha-button>
        </div>
      </div>
    </FunctionListWrapper>
  )
}
